<div class="popupClose">
    <img src="/icons/close-kb.svg" mat-dialog-close width="20px" alt="Close Privacy Policy Popup">
</div>
<mat-dialog-content>
    <cx-page-slot position="PrivacyPolicyLink"></cx-page-slot>
    <!-- kindly rteplace the position of the slot with correct name -->
</mat-dialog-content>